import React, { useState, useRef, useEffect,useContext } from 'react';
import { convertFromRaw, EditorState } from 'draft-js';
import { Box, Grid,  Link as MuiLink, Typography, Button,Avatar, Card,CardContent, CardMedia, Checkbox, List, ListItem, Divider, Snackbar, Alert, Rating } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LuAlarmClock } from "react-icons/lu";
import { RiRestaurantFill } from "react-icons/ri";
import { PiCookingPotFill } from "react-icons/pi";
import { FaFlag, FaFolder, FaInstagram } from "react-icons/fa";
import { PostContext } from '../contexts/PostContext'; // Import PostContext
import Recipe from './Recipe';

const PreviewPost = () => {
  const { postData, updatePostData } = useContext(PostContext);
 
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [headings, setHeadings] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;



  useEffect(() => {
    if (postData && postData.content) {
      const extractHeadings = (content) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = content;
        const headings = Array.from(tempDiv.querySelectorAll('h1'));
        return headings.map((heading) => ({
          text: heading.textContent,
          id: heading.textContent.replace(/\s+/g, '-').toLowerCase(), // Create a simple ID from the heading text
        }));
      };

      const extractedHeadings = extractHeadings(postData.content);
      setHeadings(extractedHeadings);
    }


  }, [postData]);



 

  async function handlePublish(ev) {
    ev.preventDefault();
  
    // Create FormData
    const data = new FormData();
    data.set('visability', postData.visability);
    data.set('postType', postData.postType);
    data.set('title', postData.title);
    data.set('summary', postData.summary);
    data.set('content', postData.content);
    data.set('category',postData.category);
    // Handle file upload (assuming postData.file is an array of file)
    if (postData.file ) {
      data.set('file', postData.file);
    }
  
    // Stringify complex data fields before adding them to FormData
    data.set('ingredients', JSON.stringify(postData.ingredients));
    data.set('instructions', JSON.stringify(postData.instructions));
    data.set('notes', JSON.stringify(postData.notes));
    data.set('additionalInfo', JSON.stringify(postData.additionalInfo));

    // Send the POST request
    try {
      const response = await fetch(`${process.env.REACT_APP_API_END_POINT}/blog/post`, {
        method: 'POST',
        body: data,
        credentials: 'include',
      });
  
      if (response.ok) {
        setOpenSnackbar(true);
        setTimeout(() => {
          // Redirect to the published post page after showing success message
          navigate(`/blog`);
        }, 2000); // Simulate a 2-second delay for the success message
      } else {
        console.error('Failed to publish post:', response.statusText);
      }
    } catch (error) {
      console.error('Error while publishing post:', error);
    }
  }
  

  // Handle closing the snackbar
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  

  
  const scaleAmount = (amount, scale) => {
    return amount ? (amount * scale).toFixed(2) : amount;
  };

 
  
   // Handle scroll to section
  //  const handleScrollToSection = (index) => {
  //   sectionRefs.current[index].current.scrollIntoView({ behavior: 'smooth' });
  // };

  const handleGoBackToEditor = () => {
   
    navigate('/blog/create-post')
  };



  return (
    <Grid 
    container
    columnGap={5}   

    sx={{ 
      padding: '3% 10%', 
       display: 'flex',
      justifyContent: 'center',
      alignItems: 'start',
       }}>
      <Grid container spacing={3} md={7}>
       
        <Grid item xs={12}>
          {/* Recipe Title */}
          <Typography variant="h4" component="h1" sx={{ mb: 2, textAlign: 'start', fontWeight: 'bold', fontSize: '3rem' }} >
            {postData.title}
          </Typography>
          <Box display="flex" alignItems="center" sx={{ marginBottom: '1rem' }}>
            <Rating value={4.5} precision={0.5} readOnly />
            <Typography variant="body1" sx={{ marginLeft: '0.5rem' }}>(4.5/5 from 30 reviews)</Typography>
          </Box>
          
          {/* Sub-heading */}
          <Typography variant="h6" color="textSecondary"  sx={{mb: '3%'}}>
            {postData.summary}
          </Typography>



             {/* "In this Post" Section (Table of Contents) */}
        {headings.length > 0 && (
          <Box
            sx={{
              mb: 4,
              p: 2,
              backgroundColor: '#eeeded',
              display: 'flex',
              flexDirection: 'row',
             
              gap: 1, // Space between items
            }}
          >

<Typography variant="h6" color="textSecondary"  sx={{mb: '3%'}}>
            In this post
          </Typography>
          
          <ul
          style={{
            display: 'flex',
            flexDirection: 'row',
            padding: 0,
            listStyle: 'none',
            margin: 0,
          }}
        >
          {headings.map((heading, index) => (
            <li
              key={index}
              style={{
                fontSize: '1.2rem',
                margin: '0.7rem 0',
      
              }}
            >
              <MuiLink
                onClick={() => {
                  const element = document.getElementById(heading.id);
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
                underline="hover"
                sx={{
                  color: '#3d54aa',
                  fontWeight: '500',
                  transition: 'color 0.3s',
                  '&:hover': {
                    color: '#ca7735',
                  },
                }}
              >
                {heading.text}
              </MuiLink>
            </li>
          ))}
        </ul>

          </Box>
        )}

          {/* Featured Image */}
          {postData.file && (
            <img
              
              style={{ width: '100%', height: 'auto', marginBottom: '2rem' }}
              src={URL.createObjectURL(postData.file)} // Create a URL from the File object
               alt={postData.title}
             
            />
          )}

                  {/* Post Content */}
      <Box
        className="content"
        sx={{
          '& h1': { 
            fontSize: '1.5rem', 
            fontWeight: 'bold', 
        
            mt: 3, 
            mb: 2, 
            id: headings.map(h => h.id),
         
          },
          '& p': { 
            fontSize: '1rem', 
            lineHeight: '1.6', 
            mb: 2,
    
          },
          '& img': { 
            width: '100%', 
            borderRadius: '8px', 
            mb: 3 
          },
          '& ul':{
            listStyleType: 'square',
            listStylePosition: 'inside',
          },
          '& li::marker': {
            color: '#ca7735', // Set bullet color to your desired color
          },
          '& li':{
            display: 'list-item', color: 'inherit'
          }
        }}
        dangerouslySetInnerHTML={{ __html: postData.content }} // Add post content
      />

           
            {postData.postType === 'recipe' && (

              <Recipe postData={postData} />
            )}


    

          <Divider sx={{ marginY: '2rem' }} />


          <Box>
          <Link to={'/blog'} className='post-category me-2' gutterBottom>
          {postData.postType}
          </Link>
          <Link to={'/blog'} className='post-category' gutterBottom>
          {postData.category}
          </Link>
          
          </Box>
          {/* Buttons: Back to Editor & Publish Recipe */}
          <Box display="flex" justifyContent="space-between" mt={4} gap={2}>
            <button
            style={{
         
            }}
              variant="outlined"
              color="secondary"
              onClick={handleGoBackToEditor} // Redirect back to the editor
              className='unit-btn'
            >
              Back to Editor
            </button>

            <button
               style={{
             
              }}
              variant="contained"
              color="primary"
              onClick={handlePublish}
              className='unit-btn active'
            >
              Publish Recipe
            </button>
          </Box>
        </Grid>
      </Grid>
Link
       {/* Featured Section */}
       <Grid container md={4} lg={4}  columnSpacing={3} 
      sx={{
        display: 'flex'
      }}
      >
        <Grid item xs={12} > 
          <Typography variant="h4" component="h3" align="center" gutterBottom>
            Featured Content
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}  > 
          <Card>
            <CardMedia
              component="img"
              height="300"
              image="https://via.placeholder.com/600x300"
              alt="Featured Recipe"
            />
            <CardContent>
              <Typography variant="h6" component="h4" gutterBottom>
                Top Recipe: Perfect Pasta
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Learn how to make the perfect pasta with this easy-to-follow recipe. From boiling the pasta to making the perfect sauce, we've got you covered.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardMedia
              component="img"
              height="300"
              image="https://via.placeholder.com/600x300"
              alt="Chef Recommendation"
            />
            <CardContent>
              <Typography variant="h6" component="h4" gutterBottom>
                Chef’s Recommendation
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Our top chef recommends this dish for a fine dining experience at home. Fresh ingredients, masterful techniques, and exceptional flavor await you.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Snackbar for success message */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity="success">
          Recipe published successfully!
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default PreviewPost;
